import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { z } from "zod";

// Enum options extracted from Ruby code
export const statusOptions = [
  { value: "running", label: "Running" },
  { value: "pending", label: "Pending" },
  { value: "success", label: "Success" },
  { value: "error", label: "Error" },
];

export const filterTimeSerieFileDateSchema = z.object({
  status_contains: z.string().nullable().optional(),
  is_python_etl: z.boolean().optional(),
  strategy_name_equals: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  time_serie_file_name_equals: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  filename_contains: z.string().nullable().optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterTimeSerieFileDateSchema = z.infer<
  typeof filterTimeSerieFileDateSchema
>;

export const fields: Field[] = [
  {
    name: "status_contains",
    label: "Status",
    type: "select",
    useTranslation: false,
    options: statusOptions,
  },
  {
    name: "strategy_name_equals",
    label: "Strategy Name",
    type: "asyncAutocomplete",
    base_url: "etl-quantilia/strategies",
    column_name: "name",
  },
  {
    name: "time_serie_file_name_equals",
    label: "Time Serie File Name",
    type: "asyncAutocomplete",
    base_url: "etl-quantilia/time_serie_files",
    column_name: "file_file_name",
  },
  {
    name: "filename_contains",
    label: "Filename",
    type: "input",
    input_type: "text",
  },
  {
    name: "created_at",
    type: "dateRange",
    label: "Created At",
    from: { name: "created_at_from", label: "From" },
    to: { name: "created_at_to", label: "To" },
    col_span: 2,
  },
  {
    name: "is_python_etl",
    label: "Is Python ETL",
    type: "checkbox",
  },
];

export const client = "qtl - etl";

export function FilterTimeSerieFileDate() {
  return (
    <FilterTable
      client={client}
      schema={filterTimeSerieFileDateSchema}
      tableName="time_serie_file_dates"
      customBuildPath={() => `${client}/time_serie_file_dates`}
      fields={fields}
    />
  );
}
